module.exports = __webpack_public_path__ + "img/jaguar_land_rover_logo.d2a6a8b0.jpg";